import { useState, useMemo, useCallback } from 'react';
import { ConditionLookupsQueryParams } from '../api';
import { useDidUpdateEffect } from '@/hooks/useDidUpdateEffect';

export interface ConditionFilters {
  search: string;
  status: string;
  speciality_id: string;
  page: string;
  limit: string;
}

export const useConditionFilters = () => {
  const [filters, setFilters] = useState<ConditionFilters>({
    search: '',
    status: 'all',
    speciality_id: 'all',
    page: '1',
    limit: '25',
  });

  useDidUpdateEffect(() => {
    setFilters((prev) => (prev.page === '1' ? prev : { ...prev, page: '1' }));
  }, [filters.search, filters.status, filters.speciality_id, filters.limit]);

  const handleFilterChange = useCallback((key: keyof ConditionFilters, value: string) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  }, []);

  const queryParams: ConditionLookupsQueryParams = useMemo(() => {
    const params: ConditionLookupsQueryParams = {
      page: parseInt(filters.page),
      per_page: parseInt(filters.limit),
    };
    
    if (filters.search) {
      params.search = filters.search;
    }
    
    if (filters.status && filters.status !== 'all') {
      params.status = filters.status as any;
    }
    
    if (filters.speciality_id && filters.speciality_id !== 'all') {
      params.speciality_id = parseInt(filters.speciality_id);
    }
    
    return params;
  }, [filters]);

  return {
    filters,
    queryParams,
    handleFilterChange,
  };
}; 
